import { createSlice } from '@reduxjs/toolkit';
import { AcceptState, AcceptSubPage } from '../types/state';

export const initialState: AcceptState = {
  paymentSelectorError: null,
  subPage: AcceptSubPage.OFFERS,
};

export const acceptSlice: any = createSlice({
  name: 'accept',
  initialState,
  reducers: {
    setPaymentSelectorError: (state, action) => {
      state.paymentSelectorError = action.payload;
    },
    setAcceptSubPage: (state, action) => {
      state.subPage = action.payload;
    },
  },
});

export const { setPaymentSelectorError, setAcceptSubPage } =
  acceptSlice.actions;

export default acceptSlice.reducer;
